// Données géographiques — République de Guinée
// 34 préfectures, ~170 sous-préfectures, quartiers détaillés pour Conakry, Coyah, Dubréka

export const GUINEE_GEO = [
  {
    nom: 'Conakry', region: 'Conakry',
    sousPrefectures: [
      { nom: 'Kaloum', quartiers: ['Almamya I','Almamya II','Boulbinet','Coronthie I','Coronthie II','Koulewondy','Manquepas','Sandervalia','Sans Fil','Téminetaye','Tombo'] },
      { nom: 'Dixinn', quartiers: ['Belle Vue École','Belle Vue Marché I','Belle Vue Marché II','Camayenne','Cameroun','Dixinn Centre I','Dixinn Centre II','Dixinn Gare','Dixinn Gare Rails','Dixinn Mosquée','Dixinn Port','Hafia Château d\'eau','Hafia I','Hafia II','Hafia III','Hafia Minière I','Hafia Minière II','Hafia Minière Centre','Hafia Mosquée Kénien','Landréah','Minière Cité'] },
      { nom: 'Matam', quartiers: ['Bonfi','Bonfi Marché','Bonfi Routière','Boussoura','Carrière Centre','Carrière Cité','Coléah Centre','Coléah Cité','Coléah Domino','Coléah Imprimerie','Hermakonon Mosquée','Hermakonon Permanence','Lanseboundji','Madina Centre','Madina Cité','Madina Marché','Madina Mosquée','Madina École','Mafanco','Mafanco Centre','Matam','Matam Centre','Matam Lido','Touguiwondy'] },
      { nom: 'Ratoma', quartiers: ['Taouyah','Ratoma Dispensaire','Ratoma Centre','Kaporo Rails','Hamdallaye 1','Hamdallaye 2','Koloma Soloprimo','Kipé','Kaporo Centre'] },
      { nom: 'Lambanyi', quartiers: ['Nongo Centre','Nongo Taady','Lambanyi','Yembeya','Waréah','Simbaya Gare','Yattaya Centre','Nassouroulaye','Bantounka 1','Bantounka 2','Soumambossia','Wanindara','Wanindara Rails','Kinifi'] },
      { nom: 'Sonfonia', quartiers: ['Kobayah','Yattaya Fossidet','Yattaya Centre','Sonfonia Gare 1','Sonfonia Gare 2','Sonfonia Centre 1','Sonfonia Centre 2'] },
      { nom: 'Matoto', quartiers: ['Matoto Centre','Simbaya 2','Simbaya École','Matoto Marché','Matoto Khabitaya','Sangoyah Mosquée','Sangoyah Marché','Kissosso','Kissosso Plateau','Marché Enco 5','Wanindara Dispensaire','Wanindara Marché'] },
      { nom: 'Gbessia', quartiers: ['Dabondy 1','Dabondy 2','Dabondy 3','Dabondy École','Dabondy Rails','Gbessia Cité 1','Gbessia Cité 2','Gbessia Cité 3','Gbessia École','Gbessia Centre','Gbessia Port 1','Gbessia Port 2','Dar-Es-Salam','Cité de l\'Air','Béhanzin','Tanènè Marché','Tanènè Mosquée','Yimbaya École','Yimbaya Permanence','Yimbaya Port','Hamdallaye Mosquée','Yimbaya Tannerie','Simbaya 1','Koloma 1','Koloma 2','Nassouroulaye'] },
      { nom: 'Tombolia', quartiers: ['Enta Marché','Enta Fassa','Tombolia','Tombolia Plateau','Dabompa Village','Dabompa Plateau','Lansanayah'] },
      { nom: 'Kagbélén', quartiers: ['Kagbélén Plateau','Kénendé','Nèguèyah'] },
      { nom: 'Sanoyah', quartiers: ['Sanoyah Km36','Lansanayah','Fassiah Centre'] },
      { nom: 'Manéah', quartiers: ['Tanènè 1','Kindiadi','Jacopé','Gomboyah'] },
      { nom: 'Kassa', quartiers: ['Kassa','Soro','Room','Fotoba','Rogbanè'] },
    ],
  },
  {
    nom: 'Coyah', region: 'Kindia',
    sousPrefectures: [
      { nom: 'Coyah Centre', quartiers: ['Centre Administratif','Bangouya','Dariya','Kakimbo','Kilomètre 36','Kilomètre 42','Kokouma','Madina Coyah','Sandémba','Sérédou Coyah','Yimbaya Coyah'] },
      { nom: 'Kouriah',      quartiers: ['Kouriah Centre','Bantounga','Sengueya','Bangouyah'] },
      { nom: 'Manéah',       quartiers: ['Manéah Centre','Kagbelen','Kolabouyi','Sonfonia Manéah','Tanènè Manéah','Koliagbe','Cité des Nations'] },
      { nom: 'Ouassou',      quartiers: ['Ouassou Centre','Moussayah'] },
      { nom: 'Wonkifong',    quartiers: ['Wonkifong Centre','Bordo','Konsankoro','Tagbé','Farmoriah Coyah'] },
    ],
  },
  {
    nom: 'Dubréka', region: 'Kindia',
    sousPrefectures: [
      { nom: 'Dubréka Centre', quartiers: ['Centre Administratif Dubréka','Almamya Dubréka','Benty','Douprou','Fassaya','Kolabouyi Dubréka','Moussayah Dubréka','Quartier Peulh','Sanyah','Tanènè Dubréka'] },
      { nom: 'Kassa',          quartiers: ['Île de Kassa','Île Roume','Île Tamara','Île Fotoba','Kassa Centre'] },
      { nom: 'Khorira',        quartiers: ['Khorira Centre','Bambaya'] },
      { nom: 'Tanènè',         quartiers: ['Tanènè Centre','Kamaranka','Souguéta-Tanènè'] },
      { nom: 'Woya',           quartiers: ['Woya Centre','Kolobènè'] },
    ],
  },
  {
    nom: 'Forécariah', region: 'Kindia',
    sousPrefectures: [
      { nom: 'Forécariah Centre', quartiers: [] },
      { nom: 'Benty',             quartiers: [] },
      { nom: 'Farmoriah',         quartiers: [] },
      { nom: 'Kaback',            quartiers: [] },
      { nom: 'Mafèrinyah',        quartiers: [] },
      { nom: 'Moussayah',         quartiers: [] },
      { nom: 'Sangoyah',          quartiers: [] },
    ],
  },
  {
    nom: 'Kindia', region: 'Kindia',
    sousPrefectures: [
      { nom: 'Kindia Centre',  quartiers: [] },
      { nom: 'Bangouya',       quartiers: [] },
      { nom: 'Damakhania',     quartiers: [] },
      { nom: 'Friguiagbé',     quartiers: [] },
      { nom: 'Kollet',         quartiers: [] },
      { nom: 'Madina-Oula',    quartiers: [] },
      { nom: 'Molota',         quartiers: [] },
      { nom: 'Souguéta',       quartiers: [] },
      { nom: 'Soulouta',       quartiers: [] },
    ],
  },
  {
    nom: 'Télimélé', region: 'Kindia',
    sousPrefectures: [
      { nom: 'Télimélé Centre', quartiers: [] },
      { nom: 'Bourouwal-Tappé', quartiers: [] },
      { nom: 'Daramagnaki',     quartiers: [] },
      { nom: 'Gougoudjé',       quartiers: [] },
      { nom: 'Hamdalaye',       quartiers: [] },
      { nom: 'Mombéya',         quartiers: [] },
      { nom: 'Santou',          quartiers: [] },
      { nom: 'Thionthian',      quartiers: [] },
    ],
  },
  {
    nom: 'Boké', region: 'Boké',
    sousPrefectures: [
      { nom: 'Boké Centre',  quartiers: [] },
      { nom: 'Bintimodiya',  quartiers: [] },
      { nom: 'Camvane',      quartiers: [] },
      { nom: 'Kanfarandé',   quartiers: [] },
      { nom: 'Kolaboui',     quartiers: [] },
      { nom: 'Sangarédi',    quartiers: [] },
      { nom: 'Tougnifily',   quartiers: [] },
    ],
  },
  {
    nom: 'Boffa', region: 'Boké',
    sousPrefectures: [
      { nom: 'Boffa Centre', quartiers: [] },
      { nom: 'Douprou',      quartiers: [] },
      { nom: 'Koba',         quartiers: [] },
      { nom: 'Mankountan',   quartiers: [] },
      { nom: 'Tamita',       quartiers: [] },
    ],
  },
  {
    nom: 'Fria', region: 'Boké',
    sousPrefectures: [
      { nom: 'Fria Centre', quartiers: [] },
      { nom: 'Banguigny',   quartiers: [] },
    ],
  },
  {
    nom: 'Gaoual', region: 'Boké',
    sousPrefectures: [
      { nom: 'Gaoual Centre',   quartiers: [] },
      { nom: 'Balaki',          quartiers: [] },
      { nom: 'Foulamory',       quartiers: [] },
      { nom: 'Kollangui',       quartiers: [] },
      { nom: 'Koumbia',         quartiers: [] },
      { nom: "Wendou-M'Bour",   quartiers: [] },
    ],
  },
  {
    nom: 'Koundara', region: 'Boké',
    sousPrefectures: [
      { nom: 'Koundara Centre', quartiers: [] },
      { nom: 'Bande',           quartiers: [] },
      { nom: 'Guingan',         quartiers: [] },
      { nom: 'Sara',            quartiers: [] },
      { nom: 'Touba-Koundara',  quartiers: [] },
      { nom: 'Termessé',        quartiers: [] },
    ],
  },
  {
    nom: 'Dalaba', region: 'Mamou',
    sousPrefectures: [
      { nom: 'Dalaba Centre',  quartiers: [] },
      { nom: 'Bodié',          quartiers: [] },
      { nom: 'Ditinn',         quartiers: [] },
      { nom: 'Kankalabé',      quartiers: [] },
      { nom: 'Ndéma',          quartiers: [] },
      { nom: 'Pellel',         quartiers: [] },
      { nom: 'Sanoun',         quartiers: [] },
    ],
  },
  {
    nom: 'Mamou', region: 'Mamou',
    sousPrefectures: [
      { nom: 'Mamou Centre',   quartiers: [] },
      { nom: 'Bouliwel',       quartiers: [] },
      { nom: 'Dounet',         quartiers: [] },
      { nom: 'Gongoré',        quartiers: [] },
      { nom: 'Ouré-Kaba',      quartiers: [] },
      { nom: 'Saramoussaya',   quartiers: [] },
      { nom: 'Tolo',           quartiers: [] },
      { nom: 'Yembéring',      quartiers: [] },
    ],
  },
  {
    nom: 'Pita', region: 'Mamou',
    sousPrefectures: [
      { nom: 'Pita Centre',    quartiers: [] },
      { nom: 'Bourouwal-Pita', quartiers: [] },
      { nom: 'Maci',           quartiers: [] },
      { nom: 'Ninguélandé',    quartiers: [] },
      { nom: 'Sankou',         quartiers: [] },
      { nom: 'Timbi-Madina',   quartiers: [] },
      { nom: 'Timbi-Touni',    quartiers: [] },
    ],
  },
  {
    nom: 'Labé', region: 'Labé',
    sousPrefectures: [
      { nom: 'Labé Centre',    quartiers: [] },
      { nom: 'Bourdé',         quartiers: [] },
      { nom: 'Diari',          quartiers: [] },
      { nom: 'Kouramangui',    quartiers: [] },
      { nom: 'Noussy',         quartiers: [] },
      { nom: 'Popodara',       quartiers: [] },
      { nom: 'Tountouroun',    quartiers: [] },
    ],
  },
  {
    nom: 'Koubia', region: 'Labé',
    sousPrefectures: [
      { nom: 'Koubia Centre',  quartiers: [] },
      { nom: 'Balaki-Koubia',  quartiers: [] },
      { nom: 'Manda',          quartiers: [] },
    ],
  },
  {
    nom: 'Lélouma', region: 'Labé',
    sousPrefectures: [
      { nom: 'Lélouma Centre',  quartiers: [] },
      { nom: 'Diari-Lélouma',   quartiers: [] },
      { nom: 'Kebaly',          quartiers: [] },
      { nom: 'Kollet-Lélouma',  quartiers: [] },
      { nom: 'Maci-Lélouma',    quartiers: [] },
    ],
  },
  {
    nom: 'Mali', region: 'Labé',
    sousPrefectures: [
      { nom: 'Mali Centre',     quartiers: [] },
      { nom: 'Doko',            quartiers: [] },
      { nom: 'Fassankoni',      quartiers: [] },
      { nom: 'Gadha-Woundou',   quartiers: [] },
      { nom: 'Gayah',           quartiers: [] },
      { nom: 'Madina-Wora',     quartiers: [] },
      { nom: 'Touba-Mali',      quartiers: [] },
      { nom: 'Yembering-Mali',  quartiers: [] },
    ],
  },
  {
    nom: 'Tougué', region: 'Labé',
    sousPrefectures: [
      { nom: 'Tougué Centre',   quartiers: [] },
      { nom: 'Donghol-Touma',   quartiers: [] },
      { nom: 'Doumaïa',         quartiers: [] },
      { nom: 'Guémou',          quartiers: [] },
      { nom: 'Kollet-Tougué',   quartiers: [] },
    ],
  },
  {
    nom: 'Dabola', region: 'Faranah',
    sousPrefectures: [
      { nom: 'Dabola Centre',  quartiers: [] },
      { nom: 'Arfamoussaya',   quartiers: [] },
      { nom: 'Banko',          quartiers: [] },
      { nom: 'Kindoye',        quartiers: [] },
      { nom: 'Konindou',       quartiers: [] },
    ],
  },
  {
    nom: 'Dinguiraye', region: 'Faranah',
    sousPrefectures: [
      { nom: 'Dinguiraye Centre', quartiers: [] },
      { nom: 'Banora',            quartiers: [] },
      { nom: 'Dialakoro',         quartiers: [] },
      { nom: 'Ganao',             quartiers: [] },
      { nom: 'Kalinko',           quartiers: [] },
      { nom: 'Lero',              quartiers: [] },
      { nom: 'Sélouma',           quartiers: [] },
    ],
  },
  {
    nom: 'Faranah', region: 'Faranah',
    sousPrefectures: [
      { nom: 'Faranah Centre',  quartiers: [] },
      { nom: 'Bania',           quartiers: [] },
      { nom: 'Baro',            quartiers: [] },
      { nom: 'Beindou',         quartiers: [] },
      { nom: 'Gbérédou',        quartiers: [] },
      { nom: 'Heremakonon',     quartiers: [] },
      { nom: 'Kobikoro',        quartiers: [] },
      { nom: 'Koumandou',       quartiers: [] },
      { nom: 'Sandenia',        quartiers: [] },
      { nom: 'Tiro',            quartiers: [] },
    ],
  },
  {
    nom: 'Kissidougou', region: 'Faranah',
    sousPrefectures: [
      { nom: 'Kissidougou Centre', quartiers: [] },
      { nom: 'Bardou',             quartiers: [] },
      { nom: 'Firawa',             quartiers: [] },
      { nom: 'Gbangbadou',         quartiers: [] },
      { nom: 'Kondiadou',          quartiers: [] },
      { nom: 'Yendé-Mougoula',     quartiers: [] },
    ],
  },
  {
    nom: 'Kankan', region: 'Kankan',
    sousPrefectures: [
      { nom: 'Kankan Centre',      quartiers: [] },
      { nom: 'Baranama',           quartiers: [] },
      { nom: 'Babila',             quartiers: [] },
      { nom: 'Foloko',             quartiers: [] },
      { nom: 'Karfamory',          quartiers: [] },
      { nom: 'Koba-Kankan',        quartiers: [] },
      { nom: 'Missamana',          quartiers: [] },
      { nom: 'Sabadou-Baranama',   quartiers: [] },
      { nom: 'Tinti-Oulen',        quartiers: [] },
    ],
  },
  {
    nom: 'Kérouané', region: 'Kankan',
    sousPrefectures: [
      { nom: 'Kérouané Centre', quartiers: [] },
      { nom: 'Banankoro',       quartiers: [] },
      { nom: 'Damaro',          quartiers: [] },
      { nom: 'Koropara',        quartiers: [] },
      { nom: 'Linko',           quartiers: [] },
      { nom: 'Sibiribaro',      quartiers: [] },
    ],
  },
  {
    nom: 'Kouroussa', region: 'Kankan',
    sousPrefectures: [
      { nom: 'Kouroussa Centre', quartiers: [] },
      { nom: 'Baro-Kouroussa',   quartiers: [] },
      { nom: 'Bate-Nafadji',     quartiers: [] },
      { nom: 'Doura',            quartiers: [] },
      { nom: 'Fermessadou',      quartiers: [] },
      { nom: 'Koumana',          quartiers: [] },
      { nom: 'Sanguiana',        quartiers: [] },
      { nom: 'Sido',             quartiers: [] },
      { nom: 'Tamba',            quartiers: [] },
      { nom: 'Tokounou',         quartiers: [] },
    ],
  },
  {
    nom: 'Mandiana', region: 'Kankan',
    sousPrefectures: [
      { nom: 'Mandiana Centre',  quartiers: [] },
      { nom: 'Alcondji',         quartiers: [] },
      { nom: 'Dialafara',        quartiers: [] },
      { nom: 'Faralako',         quartiers: [] },
      { nom: 'Karifamoriah',     quartiers: [] },
      { nom: 'Morodou',          quartiers: [] },
      { nom: 'Saladou',          quartiers: [] },
    ],
  },
  {
    nom: 'Siguiri', region: 'Kankan',
    sousPrefectures: [
      { nom: 'Siguiri Centre', quartiers: [] },
      { nom: 'Doko-Siguiri',   quartiers: [] },
      { nom: 'Franwalia',      quartiers: [] },
      { nom: 'Kiniéran',       quartiers: [] },
      { nom: 'Norassoba',      quartiers: [] },
      { nom: 'Niandankoro',    quartiers: [] },
      { nom: 'Signiri',        quartiers: [] },
    ],
  },
  {
    nom: 'Beyla', region: "N'Zérékoré",
    sousPrefectures: [
      { nom: 'Beyla Centre',   quartiers: [] },
      { nom: 'Bignamou',       quartiers: [] },
      { nom: 'Bounouma',       quartiers: [] },
      { nom: 'Diassodou',      quartiers: [] },
      { nom: 'Foulakounda',    quartiers: [] },
      { nom: 'Konima',         quartiers: [] },
      { nom: 'Laine',          quartiers: [] },
      { nom: 'Moussadou',      quartiers: [] },
      { nom: 'Sinko',          quartiers: [] },
    ],
  },
  {
    nom: 'Guéckédou', region: "N'Zérékoré",
    sousPrefectures: [
      { nom: 'Guéckédou Centre', quartiers: [] },
      { nom: 'Bawa',             quartiers: [] },
      { nom: 'Fangamadou',       quartiers: [] },
      { nom: 'Kassadou',         quartiers: [] },
      { nom: 'Nongoa',           quartiers: [] },
    ],
  },
  {
    nom: 'Lola', region: "N'Zérékoré",
    sousPrefectures: [
      { nom: 'Lola Centre',   quartiers: [] },
      { nom: 'Bossou',        quartiers: [] },
      { nom: 'Gouécké',       quartiers: [] },
      { nom: 'Koyama',        quartiers: [] },
      { nom: "N'zoo",         quartiers: [] },
      { nom: 'Tounkarata',    quartiers: [] },
    ],
  },
  {
    nom: 'Macenta', region: "N'Zérékoré",
    sousPrefectures: [
      { nom: 'Macenta Centre', quartiers: [] },
      { nom: 'Baladou',        quartiers: [] },
      { nom: 'Bofossou',       quartiers: [] },
      { nom: 'Kouankan',       quartiers: [] },
      { nom: 'Lengo',          quartiers: [] },
      { nom: 'Nzapa',          quartiers: [] },
      { nom: 'Sérédou',        quartiers: [] },
      { nom: 'Simpassou',      quartiers: [] },
      { nom: 'Vassarédou',     quartiers: [] },
      { nom: 'Womey',          quartiers: [] },
    ],
  },
  {
    nom: "N'Zérékoré", region: "N'Zérékoré",
    sousPrefectures: [
      { nom: "N'Zérékoré Centre",    quartiers: [] },
      { nom: 'Daro',                 quartiers: [] },
      { nom: "Gouécké-N'Zérékoré",   quartiers: [] },
      { nom: 'Koulé',                quartiers: [] },
      { nom: 'Samoe',                quartiers: [] },
      { nom: 'Zowolo',               quartiers: [] },
    ],
  },
  {
    nom: 'Yomou', region: "N'Zérékoré",
    sousPrefectures: [
      { nom: 'Yomou Centre',  quartiers: [] },
      { nom: 'Diécké',        quartiers: [] },
      { nom: 'Koulé-Yomou',   quartiers: [] },
      { nom: 'Ouéassou',      quartiers: [] },
    ],
  },
];

// Helper : liste des noms de préfecture
export const PREFECTURES = GUINEE_GEO.map(p => p.nom);

// Helper : sous-préfectures d'une préfecture
export function getSousPrefectures(prefNom) {
  const p = GUINEE_GEO.find(p => p.nom === prefNom);
  return p ? p.sousPrefectures.map(sp => sp.nom) : [];
}

// Helper : quartiers d'une sous-préfecture
export function getQuartiers(prefNom, spNom) {
  const p = GUINEE_GEO.find(p => p.nom === prefNom);
  if (!p) return [];
  const sp = p.sousPrefectures.find(sp => sp.nom === spNom);
  return sp ? sp.quartiers : [];
}
